/* List of Redux constants */
export const REFERENCE_SET_LOADING = '@reference/set-loading';
export const REFERENCE_SET_CODE_STATUS = '@reference/set-code-status';
export const REFERENCE_SET_CANDIDATE_REFERENCE = '@reference/set-candidate-reference';

/* List of Sagas constants */
export const REFERENCE_VALIDATE_CANDIDATE_REFERENCE_CODE = '@reference/validate-candidate-reference-code';
export const REFERENCE_DECLINE_CANDIDATE_REFERENCE = '@reference/decline-candidate-reference';
export const REFERENCE_GET_CANDIDATE_REFERENCE_DETAILS_SUMMARY = '@reference/get-candidate-reference-details-summary';
export const REFERENCE_COMPLETE_CANDIDATE_REFERENCE = '@reference/complete-candidate-reference';
export const REFERENCE_PRINT_CANDIDATE_REFERENCE = '@reference/print-candidate-reference';



// WEBPACK FOOTER //
// ./src/actions/references/types.js